import { render } from "./UpdateBuss.vue?vue&type=template&id=03de06f7"
import script from "./UpdateBuss.vue?vue&type=script&lang=js"
export * from "./UpdateBuss.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__